module.exports = __webpack_public_path__ + "img/Certificaciones.db900e7b.png";